import bootstrap from './bootstrap';
import { updateConfig } from './helpers';

export default function install(Vue, options = {}) {
  updateConfig({ ...options, $vue: Vue });
  bootstrap();
}
